import React from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116;

function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;

              default:
                return u;
            }

        }

      case d:
        return u;
    }
  }
}

function A(a) {
  return z(a) === m;
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var printWarning = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function printWarning$1(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var ParallaxCard = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ParallaxCard, _React$Component);

  function ParallaxCard() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      rootElemWidth: 0,
      rootElemHeight: 0,
      isOnHover: false,
      container: {},
      shine: {},
      layers: _this.props.children ? _this.props.children.length ? _this.props.children : [_this.props.children] : [React.createElement('div', {
        style: _this.props.style
      }, [])],
      layersTransform: []
    };

    _this.componentDidMount = function () {
      if (!_this.props.isStatic) {
        _this.setState({
          rootElemWidth: _this.node.clientWidth || _this.node.offsetWidth || _this.node.scrollWidth,
          rootElemHeight: _this.node.clientHeight || _this.node.offsetHeight || _this.node.scrollHeight
        });
      }
    };

    _this.handleMove = function (_ref) {
      var pageX = _ref.pageX,
          pageY = _ref.pageY;
      var layerCount = _this.state.layers ? _this.state.layers.length : 1;
      var _this$state = _this.state,
          rootElemWidth = _this$state.rootElemWidth,
          rootElemHeight = _this$state.rootElemHeight;
      var bodyScrollTop = document.body.scrollTop || document.getElementsByTagName('html')[0].scrollTop;
      var bodyScrollLeft = document.body.scrollLeft;

      var offsets = _this.node.getBoundingClientRect();

      var wMultiple = 320 / rootElemWidth;
      var multiple = wMultiple * 0.07;
      var offsetX = 0.52 - (pageX - offsets.left - bodyScrollLeft) / rootElemWidth;
      var offsetY = 0.52 - (pageY - offsets.top - bodyScrollTop) / rootElemHeight;
      var dy = pageY - offsets.top - bodyScrollTop - rootElemHeight / 2;
      var dx = pageX - offsets.left - bodyScrollLeft - rootElemWidth / 2;
      var yRotate = (offsetX - dx) * multiple;
      var xRotate = (dy - offsetY) * (Math.min(offsets.width / offsets.height, 1) * multiple);
      var arad = Math.atan2(dy, dx);
      var rawAngle = arad * 180 / Math.PI - 90;
      var angle = rawAngle < 0 ? rawAngle + 360 : rawAngle;

      _this.setState({
        container: {
          transform: "rotateX(" + xRotate + "deg) rotateY(" + yRotate + "deg) " + (_this.state.isOnHover ? ' scale3d(1.07,1.07,1.07)' : '')
        },
        shine: {
          background: "linear-gradient(" + angle + "deg, rgba(255, 255, 255, " + (pageY - offsets.top - bodyScrollTop) / rootElemHeight * _this.props.shineStrength + ") 0%, rgba(255, 255, 255, 0) 80%)",
          transform: "translateX(" + (offsetX * layerCount - 0.1) + "px) translateY(" + (offsetY * layerCount - 0.1) + "px)"
        },
        layersTransform: _this.state.layers ? _this.state.layers.map(function (_, idx) {
          return {
            transform: "translateX(" + offsetX * layerCount * (idx * 1 / wMultiple) + "px) translateY(" + offsetY * layerCount * (idx * 1 / wMultiple) + "px)"
          };
        }) : _this.props.children
      });
    };

    _this.handleTouchMove = function (evt) {
      evt.preventDefault();
      var _evt$touches$ = evt.touches[0],
          pageX = _evt$touches$.pageX,
          pageY = _evt$touches$.pageY;

      _this.handleMove({
        pageX: pageX,
        pageY: pageY
      });
    };

    _this.handleEnter = function () {
      _this.setState({
        isOnHover: true
      });
    };

    _this.handleLeave = function () {
      _this.setState({
        isOnHover: false,
        container: {},
        shine: {},
        layersTransform: []
      });
    };

    _this.renderLayers = function () {
      return /*#__PURE__*/React.createElement("div", {
        className: "parallax-card-layers",
        style: _extends({
          position: 'relative',
          borderRadius: _this.props.borderRadius,
          overflow: 'hidden',
          transformStyle: 'preserve-3d',
          backgroundColor: 'white',
          zIndex: '2'
        }, _this.props.style)
      }, _this.state.layersTransform && React.Children.map(_this.state.layers, function (child, idx) {
        return React.cloneElement(child, {
          style: _extends({}, child.props.style, {
            transition: 'all 0.1s ease-out',
            zIndex: '4'
          }, _this.state.layersTransform[idx] ? _this.state.layersTransform[idx] : {})
        });
      }));
    };

    return _this;
  }

  var _proto = ParallaxCard.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex'
      }
    }, /*#__PURE__*/React.createElement("div", {
      onClick: this.props.onClick,
      style: {
        borderRadius: this.props.borderRadius,
        transformStyle: 'preserve-3d',
        WebkitTapHighlightColor: 'rgba(#000, 0)',
        cursor: this.props.cursorPointer ? 'pointer' : false,
        transform: "perspective(" + this.state.rootElemWidth * 3 + "px)",
        zIndex: this.state.isOnHover ? '9' : 'unset'
      },
      onMouseMove: this.handleMove,
      onMouseEnter: this.handleEnter,
      onMouseLeave: this.handleLeave,
      onTouchMove: this.handleTouchMove,
      onTouchStart: this.handleEnter,
      onTouchEnd: this.handleLeave,
      className: "parallax-card",
      ref: function ref(node) {
        _this2.node = node;
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "parallax-card-container",
      style: _extends({
        position: 'relative',
        borderRadius: this.props.borderRadius,
        transition: 'all 0.2s ease-out'
      }, this.state.container)
    }, /*#__PURE__*/React.createElement("div", {
      className: "parallax-card-shadow",
      style: {
        position: 'absolute',
        top: '5%',
        left: '5%',
        right: '5%',
        bottom: '5%',
        transition: 'all 0.2s ease-out',
        zIndex: '0',
        boxShadow: this.state.isOnHover ? '0 45px 100px rgba(14, 21, 47, 0.4), 0 16px 40px rgba(14, 21, 47, 0.4)' : '0 8px 30px rgba(14, 21, 47, 0.6)'
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "parallax-card-shine",
      style: _extends({
        position: 'absolute',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        borderRadius: this.props.borderRadius,
        background: "linear-gradient(135deg,rgba(255, 255, 255, " + this.props.shineStrength / 1.6 + ") 0%,rgba(255, 255, 255, 0) 60%)",
        zIndex: '8'
      }, this.state.shine)
    }), this.renderLayers())));
  };

  return ParallaxCard;
}(React.Component);

ParallaxCard.defaultProps = {
  isStatic: false,
  borderRadius: '20px',
  shineStrength: 0.4,
  cursorPointer: true
};
export default ParallaxCard;